/*
# -----------------------------------------------------------------------------
# Component: fireDataMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 08/Feb/2020
# Comments: Responsible for shared components - Fire Parameters
# -----------------------------------------------------------------------------
*/
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export const fireDataMixin = {
  data() {
    return {
      sideFunction: [
        {
          text: 'Fire Construction Class',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'fireConstrnCls' }
        },
        {
          text: 'Fire Occupancy',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'fireOccpncy' }
        },
        {
          text: 'Fire Occupation Class',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'fireOccpnCls' }
        },
        {
          text: 'Fire Occupation Class Limit',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'fireOccpnClsLim' }
        }
      ]
    }
  },
  methods: {
    doInit(pKey) {
      const apiURI = this.menu.fireParamList
      if (apiURI) {
        const params = {
          paramKey: pKey,
          paramString: ''
        }
        this.loading = true
        this.$http.get(expandURI(apiURI, params)).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(result => {
              const convertList = {
                paramName: result.paramName,
                paramDesc: result.paramDesc
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  computed: {
    menu() {
      return this.$store.state.fireParam.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
